import { Badge, Group } from "@mantine/core"
import uniq from "lodash/uniq"
import { DateTime } from "@/components/utils"
import type { TSurveyAnswer, TSurveyQuestion } from "@/types"
import type { IMultiAnswerProps } from "./types"
import { filterAnswersWithValue } from "./utils"

interface IProps extends IMultiAnswerProps {
  format?: string
}

export function MultiAnswerDate({ answers, question, format = "L" }: IProps) {
  const answersWithValues = filterAnswersWithValue(answers)
  const values = uniq(answersWithValues.map((a) => getValue(a, question))).sort((a, b) => a - b)

  return (
    <Group gap="xs">
      {values.map((value) => (
        <Badge key={value} size="lg" radius="sm" fw={500} fz="sm" variant="outline" color="gray.7">
          <DateTime timestamp={value} format={format} />
        </Badge>
      ))}
    </Group>
  )
}

function getValue(answer: TSurveyAnswer, question: { type: TSurveyQuestion["type"] }) {
  const value = answer.value as number
  return question.type == "personal" ? value * 1000 : (answer.value as number)
}
